
<script>

// CommitChart.js
import { Line, mixins } from "vue-chartjs";

export default {
  name: 'LineChart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ["options"],
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, this.options)
  }
}

</script>

<style>



</style>


// WEBPACK FOOTER //
// src/components/LineChart.vue